import { Dispatch, ThunkAction } from '../../../types/actions';
import { IGetState, TListId } from '../../../types/types';
import { cardsArchive } from '../card/card/cardsArchive';
import { getListCardIdsByStatus } from '../../../store/model/selectors/getListCardIdsByStatus';
import { TStatus } from '../../../types/model';
import { listSetStatus } from './listSetStatus';
import { cardsUnarchive } from '../card/card/cardsUnarchive';

export const listUnarchive = (
    listId: TListId
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        const state = getState();
        const cardIds = getListCardIdsByStatus(state, listId, TStatus.STATUS_ARCHIVE);
        return dispatch(cardsUnarchive(cardIds))
            .then(() => {
                return dispatch(listSetStatus(listId, TStatus.STATUS_ACTIVE))
            })
    };
    return action;
};
